import Layout from "../../../components/Layout/Layout";
// import useStyles from "../styles";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import Button from "../../../components/Button/Button";
import { Grid } from "@mui/material";
import { ToastContainer } from "react-toastify";

const ExaminationReview = () => {
  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/schools/:id"
                link_one_name="Great Academy"
                link_two="/schools/school-paper-review"
                link_two_name="School Paper Review"
                active="Mathematics"
                description="See all examination question papers submitted pending approval."
              />
            </div>
          </div>
          <Grid container spacing={4}>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <div className="left-container">
                <h4>Mathematics Examination Paper</h4>
                <h6>Update your Examination papers here</h6>
                <div className="flex gap-10">
                  <Button variant="primary" buttonSize="small" color="btndefault" buttonName="Approve" />
                  <Button variant="primaryoutline" buttonSize="small" color="btnfontprimary" buttonName="Reject" />
                </div>
              </div>
            </Grid>
            <Grid item lg={9} md={8} sm={12} xs={12}>
              <div className="right-container">
              </div>
            </Grid>
            <ToastContainer />
          </Grid>
        </>
      }
    />
  );
};

export default ExaminationReview;
